import i18n from "../i18n";

// @ts-ignore
import { moment, emailRegex } from "cwb-react";

export const language_code: any = {
  0: "en",
  1: "fr",
  2: "en_uk",
  3: "es",
  99: "nb",
};

export const localeKeys = { en: 0, fr: 1, en_uk: 2, es: 3, nb: 99 };

export const detectBrowserLang =
  (navigator.languages && navigator.languages[0]) || navigator.language;

export const setBrowserLang = () => {
  const browserLang = detectBrowserLang.toLowerCase();
  const locale = browserLang.split("-")[0];
  if (browserLang === "en-gb") {
    i18n.changeLanguage("en_uk");
    moment.moment.locale("en-gb");
  } else if (localeKeys.hasOwnProperty(locale)) {
    i18n.changeLanguage(browserLang.split("-")[0]);
    moment.moment.locale(locale);
  } else {
    i18n.changeLanguage("en");
    moment.moment.locale("en");
  }
};

export const buildTSRoleId = (teamShareId: any, roleId: any) =>
  `${teamShareId}_${roleId}`;

export const isTodayAudition = (
  auditionDate: string
) => {
  const auditionDay = moment.moment(auditionDate);
  const today = moment.moment();
  return auditionDay.isSame(today, "day");
};

export const isPastAudition = (
  auditionEndTime: string,
  auditionDate: string
) => {
  const auditionEndTime24hourClock = moment.moment(auditionEndTime, ["h:mm A"]);

  if (moment.moment(auditionDate).isBefore(moment.moment(), "day")) return true;

  if (moment.moment(auditionDate).isSame(moment.moment(), "day")) {
    if (auditionEndTime24hourClock.isBefore(moment.moment(), "time")) {
      return true;
    }
  }

  return false;
};

export const isPastAuditionCheckInOut = (
  auditionEndTime: string,
  auditionDate: string
) => {
  if (moment.moment(auditionDate).isBefore(moment.moment(), "day")) return true;

  return false;
};

export const isFutureAudition = (
  auditionStartTime: string,
  auditionDate: string
) => {
  // const auditionStartTime24hourClock = moment.moment(auditionStartTime, [
  //   "h:mm A",
  // ]);

  if (moment.moment(auditionDate).isAfter(moment.moment(), "day")) return true;

  if (moment.moment(auditionDate).isSame(moment.moment(), "day")) {
    // Allow check-in not allowed on same day and display warning today icon
    // if (auditionStartTime24hourClock.isAfter(moment.moment(), "time")) {
    //   return true;
    // }
  }

  return false;
};

export const isTodayOrFutureAudition = (auditionDate: string) => {
  if (moment.moment(auditionDate).isAfter(moment.moment(), "day")) return true;

  if (moment.moment(auditionDate).isSame(moment.moment(), "day")) return true;

  return false;
};

export const isEmail = (email: string): boolean => {
  return emailRegex.test(email);
};

// @ts-ignore
export const getEncodeParams = (params) =>
  Object.entries(params)
    // @ts-ignore
    .map((kv) => kv.map(encodeURIComponent).join("="))
    .join("&");


export const formatTimeOffset = (utcOffset : any) => {
  if (!utcOffset)
    return ""

  let numberOffset =  Number.parseFloat(utcOffset);
  
  let text = "";
  if (numberOffset >= 0) {
    text = "+";
  } else {
    text = "-";
  }

  numberOffset = Math.abs(numberOffset);
  const truncOffset = Math.trunc(numberOffset);
  text =  text + ("0" + truncOffset.toString()).slice(-2);

  if ((truncOffset - numberOffset) == 0) {
    return text = text + ":00";
  } else {
    return text = text + ":30";
  }
}